import { setupSketchApi } from './setup';
import { sketchIsReady } from './sketchActions';

export function registerSketchReadyHandler(store) {
  global.sketchOnReady = async function() {
    await setupSketchApi();
    store.dispatch(sketchIsReady());
  };
}
